// extracted by mini-css-extract-plugin
module.exports = {"banner":"TrialBanner_banner__3Sty3"};